import * as React from 'react';
import { LeftAlignRow } from 'components/Styled/Layout.Styled';
import { Col } from 'antd';
import { Link } from 'react-router-dom';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

export default class CardRegistrationNotificationContent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <LeftAlignRow>
          <Col>
            <p>
              Card registration is required as a one-time verification (confirmation of ownership)
              of each card being used for payments. As part of the process, a refundable
              transaction amount between $1.00 and $5.00 will be debited to your card.
            </p>
            <p>
              To begin the process, go to{' '}
              <Link to="/user-profile/register-card">Register & Verify Card</Link> under the user profile menu,
              enter and submit your card information.
            </p>
            <p>
              To complete the process, retrieve the amount that was charged to your card by
              contacting your bank and return to the Register & Verify Card page to enter the
              amount in the “Confirm Card” field.
            </p>
          </Col>
        </LeftAlignRow>
      </>
    );
  }
}
